import {
  ApolloClient,
  createHttpLink,
  from,
  HttpOptions,
  InMemoryCache,
  NormalizedCacheObject,
} from '@apollo/client';
import { isLocalDevelopment } from 'env-utils';
import { authLink } from './auth-link';
import { errorLink } from './error-link';

// Usage: createApiClient(resolveServiceUrl('CONNECTORS')) => ApolloClient<NormalizedCacheObject>
export const createApiClient = ({
  uri,
}: createApiClientOptions): ApolloClient<NormalizedCacheObject> => {
  const httpLinkOptions: HttpOptions = {
    uri,
    credentials: isLocalDevelopment() ? 'omit' : 'include',
  };

  const httpLink = createHttpLink(httpLinkOptions);

  return new ApolloClient({
    cache: new InMemoryCache({ addTypename: false }),
    link: from([authLink, errorLink, httpLink]),
  });
};

type createApiClientOptions = Pick<HttpOptions, 'uri'>;
